import React, { useCallback, ReactElement } from 'react';
import TextBlock from '../text-block/text-block.component';
import FlexContainer from '../flex-container/flex-container.component';
import Checkbox from '../checkbox/checkbox.component';
import FormFieldCheckbox from '../form-field-checkbox/form-field-checkbox.component';
import FormatService from '../../services/format-service';
import useStylesVisualEditorSectionBlock from './visual-editor-section-block.styles';

const VisualEditorSectionBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isVisible,
    isDisabled,
    isEditMode,
    isInternal,
    isInlineField,
    withNoEdit,
    fieldName,
    onVisibilityChange,
  } = props;

  const { classes } = useStylesVisualEditorSectionBlock();

  const inlineClassName: string | undefined = isInlineField ? classes.visualEditorSectionBlockInline : undefined;
  const internalClassName: string | undefined = isInternal ? classes.visualEditorSectionBlockInternal : undefined;

  const visibilityChange: Function = useCallback((isVisible: boolean): void => {
    if (onVisibilityChange) {
      onVisibilityChange(isVisible);
    }
  }, []);

  return (
    <FlexContainer
      isFullHeight
      isEnd={isInlineField}
      isCentered={!isInlineField}
      className={FormatService.formatClassNames(classes.visualEditorSectionBlock, inlineClassName, internalClassName)}
    >
      {
        !isEditMode && (
          <TextBlock>
            {isInlineField ? 'Field' : 'Block'}
            {' '}
            {withNoEdit && 'is not editable'}
            {!withNoEdit && (isVisible ? 'is visible' : 'is hidden')}
          </TextBlock>
        )
      }
      {
        isEditMode && (
          <TextBlock>
            {withNoEdit ? 'Not Editable' : 'Visible'}
          </TextBlock>
        )
      }
      {
        isEditMode && !withNoEdit && (
          (isDisabled || !fieldName) ? (
            <Checkbox isDisabled isChecked={isVisible} />
          ) : (
            <FormFieldCheckbox
              isDefault
              withNoOffset
              withNoLabelOffset
              isDisabled={isDisabled}
              name={fieldName}
              onChange={visibilityChange}
            />
          )
        )
      }
    </FlexContainer>
  );
});

export default VisualEditorSectionBlock;
